import { render, staticRenderFns } from "./VehicleIcon.vue?vue&type=template&id=a4e65248&scoped=true&"
import script from "./VehicleIcon.vue?vue&type=script&lang=js&"
export * from "./VehicleIcon.vue?vue&type=script&lang=js&"
import style0 from "./VehicleIcon.vue?vue&type=style&index=0&id=a4e65248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e65248",
  null
  
)

export default component.exports